<template>
  <div>
    <div class="head-modal">
      <div class="container">
        <h2 class="heading">
          {{ headerTitle }}
        </h2>
        <button class="icon-button" aria-label="Cerrar" @click="handleClose">
          <fluent-icon icon="dismiss" :size="16" type="outline" />
        </button>
      </div>
    </div>

    <div v-if="headerContent" class="header-content">
      {{ headerContent }}
      <span v-if="headerContentValue" class="content-value">
        {{ headerContentValue }}
      </span>
    </div>
    <slot />
  </div>
</template>

<script>
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
export default {
  components: { FluentIcon },
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    // permitimos recibir la función close desde el slot-scope (Modal.vue pasa :close)
    close: {
      type: Function,
      default: null,
    },
  },
  inject: ['modalClose'],
  methods: {
    /**
     * Cierra el modal usando la función inyectada o prop y emite el evento 'close'.
     */
    handleClose() {
      if (typeof this.modalClose === 'function') {
        this.modalClose();
      } else if (typeof this.close === 'function') {
        this.close();
      }
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.head-modal {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-normal) var(--space-normal) var(--space-normal) var(--space-large);
  width: 100%;
  background: var(--conversa2-neutral-50-color);
  border-bottom: 1px solid var(--conversa2-neutral-100-color);
  border-radius: 0;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 2.4rem;
}

.heading {
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-default);
  line-height: 24px;
  color: var(--conversa2-neutral-800-color);
  flex-grow: 1;
  margin: 0;
}

.icon-button {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 4px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.icon-button:focus {
  outline: none;
}

/* headerContent cuando se pasa por prop */
.header-content {
  font-weight: var(--font-weight-normal);
  font-style: normal;
  font-size: var(--font-size-default);
  line-height: 24px;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--conversa2-neutral-800-color);
  padding: var(--space-normal) var(--space-normal) 0 var(--space-large);
  border-radius: var(--border-radius-normal-small, 4px);
  word-wrap: break-word;
  box-sizing: border-box;
}

.content-value {
  font-weight: 700;
}
</style>
